import FileUploadSetting from "./KrFileUploadSetting.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrFileUploadSetting = install(FileUploadSetting); // 生成带有 install 方法的组件

export default KrFileUploadSetting;
